
import Hospital from "../../../assets/filled/Hospital.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HospitalIcon({ className, dataTestid = "HospitalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Hospital data-testid={dataTestid} className={classes} {...rest} />
  );
}
